/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Keyword_MovieInputs */



/**
* | output |
* | --- |
* | "Movie" |
*
* @param {Subtitle_Export_Keyword_MovieInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_keyword_movie = /** @type {((inputs?: Subtitle_Export_Keyword_MovieInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Keyword_MovieInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Film")
	if (locale === "de") return /** @type {LocalizedString} */ ("Film")
	if (locale === "it") return /** @type {LocalizedString} */ ("Film")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Фильм")
	if (locale === "es") return /** @type {LocalizedString} */ ("Película")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("电影")
	if (locale === "ja") return /** @type {LocalizedString} */ ("映画")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चलचित्र")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Filme")
	return /** @type {LocalizedString} */ ("Movie")
});